
export function modulMarkeronGoogleMaps(ref, map) {
  ref.onSnapshot(snapshot => {
    snapshot.forEach(change => {
      console.log(change.data())
      let marker = new google.maps.Marker({
        position: {
          lat: change.data().geolocation.lat,
          lng: change.data().geolocation.lng
        },    map
      })
    })
  })
}

export function modulMarkeronGoogleMapsLoad(onlineusers,map) {
  console.log('modulMarkeronGoogleMapsLoad');
  console.log(onlineusers)
  onlineusers.forEach((onlineuser)=>{
    let marker = new google.maps.Marker({
      position: {
        lat: onlineuser.geolocation.lat,
        lng: onlineuser.geolocation.lng
      },
      map
    })
  })

}




// WEBPACK FOOTER //
// ./src/firebase/GMapFunction.js